{
  "nickname": "昵称",
  "userId": "用户 ID",
  "userIdValue": "UID{{id}}",
  "connectedAppsDate": "{{label}}：{{date}}",
  "kyc": "身份认证",
  "loginPassword": "登录密码",
  "txPassword": "交易密码",
  "paymentMethod": "收付款方式",
  "connectedApps": "已连接应用",
  "connectedAppsNotConnected": "未连接",
  "connectedAppsEmpty": "暂无已连接应用",
  "connectedAppsConnectedAt": "连接时间",
  "connectedAppsLastUsedAt": "最近使用",
  "connectedAppsDisconnect": "断开",
  "connectedAppsDisconnectTitle": "断开应用连接",
  "connectedAppsDisconnectDesc": "断开后该应用将无法继续使用{{token}}支付。",
  "connectedAppsDisconnectSuccess": "已断开连接",
  "connectedAppsDisconnectFailed": "断开失败",
  "connectAppTitle": "连接应用",
  "connectAppName": "应用名称",
  "connectAppOrder": "应用订单号",
  "connectAppExpiresAt": "过期时间",
  "connectAppConfirmDesc": "确认后，该应用可在你的授权下使用{{token}}支付。",
  "connectAppConfirm": "确认连接",
  "connectAppApproveSuccess": "连接成功",
  "connectAppApproveFailed": "连接失败",
  "notification": "设置",
  "contactCS": "联系客服",
  "logoutTitle": "确认退出登录",
  "logoutDesc": "您确定要退出登录吗",
  "logout": "退出登录",
  "cancel": "取消",
  "version": "版本",
  "phone": "手机号",
  "notVerified": "未认证",
  "kycRejected": "审核未通过",
  "kycReviewing": "审核中",
  "kycVerified": "审核通过",
  "notAdded": "未添加",
  "set": "已设置",
  "notSet": "未设置",
  "nicknameNotSet": "未设置昵称",
  "copied": "已复制",
  "upgradeGuide": "升级攻略",
  "upgradeHint": "达成指定条件即可升级，享更多优惠！"
}
